import React, { Component } from "react"
import "./userDropdownMenu.scss"
import * as routes from "../../../../library/constants/routes"
import { generatePath, withRouter } from "react-router-dom"
import VerticalMenu from "../../verticalMenu/verticalMenu"
import KeyboardArrowUpOutlined from "@material-ui/icons/KeyboardArrowUpOutlined"
import KeyboardArrowDownOutlined from "@material-ui/icons/KeyboardArrowDownOutlined"
import UserAvatar from "../../../userAvatar/userAvatar"
import ClickAwayListener from "@material-ui/core/ClickAwayListener/ClickAwayListener"
import { howToArticles } from "../../../../screens/info/howTo/howToArticles"

class UserDropdownMenu extends Component {
  state = {
    active: false,
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen(() => {
      this.setState({ active: false })
    })
  }

  componentWillUnmount() {
    this.unlisten()
  }

  toggleDropdown = () => {
    this.setState((prevState) => {
      return {
        active: !prevState.active,
      }
    })
  }

  handleClose = () => {
    this.setState({ active: false })
  }

  signOut = async () => {
    // this.props.history.push(routes.BASE)
    await this.props.signOut()
  }

  render() {
    const {
      auth: { userData },
    } = this.props
    const { active } = this.state

    const menuItems = [
      {
        path: generatePath(routes.USER, {
          userId: this.props.auth.userData.id,
        }),
        label: "My page",
      },
      { type: "h-divider", id: "hd1" },
      !this.props.auth.userData.blocked &&
        !this.props.auth.userData.deleted && {
          path: routes.PROFILE_EDIT,
          label: "Edit my profile",
        },
      !this.props.auth.userData.blocked &&
        !this.props.auth.userData.deleted && {
          path: routes.PROFILE_SETTINGS,
          label: "Settings",
        },
      {
        path: generatePath(routes.HOW_TO, {
          articleId: howToArticles[0].slug,
        }),
        label: "How to",
      },
      { path: routes.CONTACT_FORM, label: "Contact us" },
      { type: "h-divider", id: "hd2" },
      { type: "button", action: this.signOut, label: "Log Out" },
    ]

    return (
      <div className="user-dropdown-menu">
        <button
          className="user-dropdown-menu__trigger"
          onClick={this.toggleDropdown}
        >
          <span className="user-dropdown-menu__user-name">
            {userData && userData.first_name ? userData.first_name : ""}
          </span>
          <UserAvatar classes="user-dropdown-menu__avatar" />
          {/*<span className="user-dropdown-menu__arrow">*/}
          {/*  {active ? (*/}
          {/*    <KeyboardArrowUpOutlined />*/}
          {/*  ) : (*/}
          {/*    <KeyboardArrowDownOutlined />*/}
          {/*  )}*/}
          {/*</span>*/}
        </button>
        {active && (
          <ClickAwayListener onClickAway={this.handleClose}>
            <div>
              {active && (
                <VerticalMenu
                  menuItems={menuItems}
                  classes="user-dropdown-menu__list"
                />
              )}
            </div>
          </ClickAwayListener>
        )}
      </div>
    )
  }
}

export default withRouter(UserDropdownMenu)
